import React from 'react';

import { PrivacyViewer } from './privacyViewer';

export function PrivacyController() {
  return <PrivacyViewer />;
}
